<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uoQqIM/tc-custom/9780226020075.jpg?1722568557200" alt="This image is the cover for the book Common Cause"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Common Cause
      </h1>
      <p class="bookDescription body article font2">
        <p>Europeans and Americans tend to hold the opinion that democracy is a uniquely Western inheritance, but in <i>The Common Cause</i>, Leela Gandhi recovers stories of an alternate version, describing a transnational history of democracy in the first half of the twentieth century through the lens of ethics in the broad sense of disciplined self-fashioning. Gandhi identifies a shared culture of perfectionism across imperialism, fascism, and liberalism—an ethic that excluded the ordinary and unexceptional. But, she also illuminates an ethic of moral imperfectionism, a set of anticolonial, antifascist practices devoted to ordinariness and abnegation that ranged from doomed mutinies in the Indian military to Mahatma Gandhi’s spiritual discipline.<br/>  <br/> Reframing the way we think about some of the most consequential political events of the era, Gandhi presents moral imperfectionism as the lost tradition of global democratic thought and offers it to us as a key to democracy’s future. In doing so, she defends democracy as a shared art of living on the other side of perfection and mounts a postcolonial appeal for an ethics of becoming common.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Leela Gandhi
      </h2>
      
      <p class="authorDescription body article"><B>Leela Gandhi</B> is professor of English at the University of Chicago. She is the founding coeditor of the journal <I>Postcolonial Studies</I> and the author, most recently, of <I>Affective Communities: Anticolonial Thought and the Politics of Friendship</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?28e0484e